import { toast } from '@britishcouncil/react-admin';
import { useCallback, useEffect, useMemo } from 'react';
import { lrwSessionStore } from 'store';
import { parseServerErrors } from 'utils';

type Props = {
  closeModal: () => void;
  speakingSessionId: number | undefined;
  lrwSessionId: number;
};

export const useUnlinkSpeakingSessionModal = ({
  closeModal,
  speakingSessionId,
  lrwSessionId,
}: Props) => {
  const [unlinkSession, { isSuccess: unlinked, error: unlinkingErrors, reset }] =
    lrwSessionStore.service.useUnLinkSpeakingSessionMutation();

  const generalErrors = useMemo(() => {
    if (unlinkingErrors) {
      return parseServerErrors(unlinkingErrors);
    } else {
      return undefined;
    }
  }, [unlinkingErrors]);

  const performUnlink = useCallback(() => {
    unlinkSession({ lrwSessionId: lrwSessionId, speakingSessionId: speakingSessionId! });
  }, [unlinkSession, speakingSessionId, lrwSessionId]);

  useEffect(() => {
    if (unlinked) {
      toast({
        type: 'success',
        title: 'Success',
        message: 'Speaking session unlinked successfully',
      });
      reset();
      closeModal();
    }
  }, [closeModal, reset, unlinked]);

  return { generalErrors, performUnlink, reset, unlinked };
};
